import { useQuery } from "@tanstack/react-query";
import { Collaboration } from "../types";
import { get } from "../services/restClient";
import { Endpoint, setEndpoint } from "../services/endpoints";
import { queryClient } from "../hooks/queryClient";

const collaborationKeys = {
    all: ["collaboration"] as const,
    lists: () => [...collaborationKeys.all, "list"] as const,
    list: (filters: string) => [...collaborationKeys.lists(), { filters }] as const,
    details: () => [...collaborationKeys.all, "detail"] as const,
    detail: (id: string) => [...collaborationKeys.details(), id] as const,
};

const getCollaborations = async () => {
    const data = await get<Collaboration[]>(setEndpoint(Endpoint.collaboration), {
        requireAuth: true,
    });
    return data;
};

export const useGetCollaborations = () => {
    return useQuery({ queryKey: ["collaboration"], queryFn: () => getCollaborations() });
};

export const prefetchCollaborations = () => {
    return queryClient.prefetchQuery({
        queryKey: ["collaboration"],
        queryFn: () => getCollaborations(),
    });
};
